import * as Comlink from "comlink";
const worker = new Worker("./worker.js", { type: "module" });
console.log("Initializing Supabase Storage drivers...");
const driver = Comlink.wrap(worker);

export default {
  getAllFiles: async () => {
    const files = await driver.getAllFiles();
    return files;
  },
  create: async ({ file }) => {
    await driver.createFile({ file });
  },
  move: async ({ id, parent_id }) => {
    await driver.moveFile({ id, parent_id });
  },
  update: async ({ id, contents }) => {
    await driver.updateFile({ id, contents });
  },
  rename: async ({ id, name }) => {
    await driver.renameFile({ id, name });
  },
  delete: async ({ id }) => {
    await driver.deleteFile({ id });
  },
  restore: async ({ filesObject }) => {
    await driver.restoreFiles({ filesObject });
  },
};
